import * as Yup from "yup";
import { PermissionEnums } from "@/Shared";

export type ResourceAccess =  {
	allRecords?: boolean;
	write?: boolean;
	read?: boolean;
	delete?: boolean;
	restore?: boolean;
	execute?: boolean;
	export?: boolean;
	audit?: boolean;
};

export type PermissionFormValues = {
	id: number;
	role: string;
	resourceAccessList: {
		[resourceKey: string]: ResourceAccess;
	};
};

export const PermissionValidationSchema = (viewEnums: PermissionEnums) =>
	Yup.object({
		id: Yup.number().optional(),

		/*
		role: stringWithNoSpecialChars({ minLength: 3, maxLength: 255 })
			.required("Le chemin du fichier est requis."),*/

			/*
		resources: validateResourceType(viewEnums.ResourceTypeEnum)
			.required("Le type de fichier est requis."),*/

	});
